export const header = 'Change your\n password';
export const buttonText = 'SUBMIT';
export const buttonSubmittingText = 'SUBMITTING...';
export const passwordChangedText = 'Your password has been changed! Use it to login again into Musiversal.';
export const backToPasswordResetText = 'Back to password reset';
export const backToLoginText = 'Back to login';
export const invalidTokenText = 'This token is no longer valid. Reset your password again.';
